export default __webpack_public_path__ + "static/media/csango10-logo-color-1.fbc394db.svg";